module.exports = __webpack_public_path__ + "img/MEDIA100.b78ad730.jpg";